import { createFileRoute } from '@tanstack/react-router';
import { OverdueMembersList } from '../../../features/overdue/components/OverdueMembersList';
import { LateFeePaymentsList } from '../../../features/overdue/components/LateFeePaymentsList';
import { DefaultRecordsList } from '../../../features/overdue/components/DefaultRecordsList';
import { usePageTitle } from '../../../lib/hooks.js';
import * as React from 'react';
import { Button } from '../../../components/ui/Button.js';

import { z } from 'zod';

const overdueSearchSchema = z.object({
  tab: z.enum(['overdue', 'late-fees', 'defaults']).optional(),
});

import { PageHeader } from '../../../components/layout/PageHeader';

export const Route = createFileRoute('/_auth/overdue/')({
  validateSearch: (search) => overdueSearchSchema.parse(search),
  component: OverduePage,
});

function OverduePage() {
  usePageTitle('Overdue & Late Fees');
  const search = Route.useSearch();
  const [activeTab, setActiveTab] = React.useState<'overdue' | 'late-fees' | 'defaults'>(search.tab || 'overdue');

  return (
    <div className="space-y-6">
      <PageHeader
        title="Late Fee & Overdue Settlement"
        subtitle="Manage overdue installments, accrued penal charges, and legal defaults."
      />

      <div className="flex space-x-4 border-b border-border pb-2">
        <Button
          variant="ghost"
          className={`px-4 py-2 rounded-none bg-transparent hover:bg-transparent text-sm font-medium ${
            activeTab === 'overdue'
              ? 'border-b-2 border-accent-500 text-accent-500 font-bold'
              : 'text-text-secondary hover:text-text-primary'
          }`}
          onClick={() => setActiveTab('overdue')}
        >
          Overdue Installments
        </Button>
        <Button
          variant="ghost"
          className={`px-4 py-2 rounded-none bg-transparent hover:bg-transparent text-sm font-medium ${
            activeTab === 'late-fees'
              ? 'border-b-2 border-accent-500 text-accent-500 font-bold'
              : 'text-text-secondary hover:text-text-primary'
          }`}
          onClick={() => setActiveTab('late-fees')}
        >
          Late Fee Payments
        </Button>
        <Button
          variant="ghost"
          className={`px-4 py-2 rounded-none bg-transparent hover:bg-transparent text-sm font-medium ${
            activeTab === 'defaults'
              ? 'border-b-2 border-accent-500 text-accent-500 font-bold'
              : 'text-text-secondary hover:text-text-primary'
          }`}
          onClick={() => setActiveTab('defaults')}
        >
          Default Records
        </Button>
      </div>

      <div>
        {activeTab === 'overdue' && <OverdueMembersList />}
        {activeTab === 'late-fees' && <LateFeePaymentsList />}
        {activeTab === 'defaults' && <DefaultRecordsList />}
      </div>
    </div>
  );
}
